import { ExperimentOutlined, HomeOutlined, ReadOutlined } from "@ant-design/icons";
import { BackTop, Button, Input, PageHeader, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";
import { ChangeEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/images/logo.png";
import { PageData } from "./declarations";
import Main from "./pages/Main";
import Tutorial from "./pages/Tutorial";

const Layout: React.FC<{ pages: PageData[], main: boolean, loading: boolean, pageData?: PageData }> = ({ pages, main, loading, pageData }) => {
    const [filter, setFilter] = useState("");
    const [data, setData] = useState<PageData[]>(pages);
    const [title, setTitle] = useState("PMA.UI Examples");

    useEffect(() => {
         
        const script = document.createElement("script");
        script.src = "https://docs.pathomation.com/sdk/pma.javascript.examples/examples/pma.ui/jquery-3.1.0.js";
        script.async = false;
        script.onload = () => {
            const script1 = document.createElement("script");
            script1.src = "https://docs.pathomation.com/sdk/pma.javascript.examples/examples/pma.ui/pma.ui.js";
            script1.async = false;
            script1.onload = () => {
                setTitle("PMA.UI Examples " + (window as any).PMA.UI.getVersion());
            }
            document.body.appendChild(script1);
        }

        document.body.appendChild(script);

        setData(pages);
    }, [pages, pageData]);

    useEffect(() => {
        filter ? setData(pages.filter((item: PageData) => item.title.toLowerCase().includes(filter.toLowerCase()) || item.tags.some(tag => {
            return tag.toLowerCase().includes(filter.toLowerCase());
        }))) : setData(pages);
    }, [filter]);

    const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };

    return <>
        <PageHeader
            title={title}
            className="site-page-header"
            subTitle="by Pathomation"
            ghost={false}
            extra={[
                <a href="../pma.javascript.documentation/" key="documentation"><Button icon={<ReadOutlined />} type="default">PMA.UI Documentation</Button></a>,
                main && <Input.Search key="filter" enterButton={false} placeholder="Search" allowClear onChange={onSearch} style={{ width: 200 }} />,
                !main && <Link to="/" key="home"><Button icon={<HomeOutlined />} type="default">Home</Button></Link>,
            ]}
            avatar={{ shape: "square", size: 64, src: logo, style: { width: "108px" } }}
            style={{ backgroundColor: "#7f9dc3" }}
        />
        <Content>
            {loading
                ? <div className="spinner">
                    <Spin size="large" />
                </div>
                : main
                    ? <Main pages={data} />
                    : <Tutorial pageData={pageData!} />
            }
        </Content>
        <BackTop />
    </>
};

export default Layout;